var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.49874 12.5515C10.4584 12.5515 12.8578 10.1522 12.8578 7.19252C12.8578 4.23281 10.4584 1.8335 7.49874 1.8335C4.53903 1.8335 2.13971 4.23281 2.13971 7.19252C2.13971 10.1522 4.53903 12.5515 7.49874 12.5515Z",
    stroke: "#2E2E2E",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.1579 11.1389L14.1936 14.1666",
    stroke: "#2E2E2E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.1d6d2ec23852d50390458bd26a7281fd.svg";
export { ForwardRef as ReactComponent };